<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationgroundlevel.header' | translate }}</span>
        </h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationgroundlevel.label' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="text" class="ir-form-set" formControlName="label" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationgroundlevel.ground-level' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big" style="width: 50%">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="levelType" />
                <div class="ir-line ir-select th-select" (click)="openLevelTypesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.levelType.value && editForm.controls.levelType.value >= 0
                        ? (editForm.controls.levelType.value | leveltype)
                        : ('plugins.installationgroundlevel.select-level-type' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectLevelTypesMenu($event)" (modalClosed)="onClose($event)" #levelTypesModal></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
